// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DUSo","question":"styles_question__OKulu","description":"styles_description__rxn9-"};